// CareThatMattersSection.js
import React from 'react';
import { ArrowRight } from 'lucide-react';
import careImage from '../assets/comprehensive-in-home-care-image.jpg';

const features = [
  { title: 'Personalised Daily Care', text: 'Support shaped around each person’s needs and routine.' },
  { title: 'Family Engagement', text: 'Transparent updates and shared decision-making.' },
  { title: 'Registered Providers', text: 'Professional, trained, and qualified care teams.' },
];

const CareThatMattersSection = () => {
  return (
    <section className="bg-white py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
        {/* Left */}
        <div>
          <p className="text-primary text-xs md:text-sm font-medium tracking-[0.22em] uppercase mb-5">
            Care That Matters
          </p>
          <h2 className="font-display font-light text-ink leading-[1.1] text-3xl md:text-4xl lg:text-5xl mb-6">
            Compassionate Services That Support Everyday Living
          </h2>
          <p className="text-muted text-base leading-relaxed max-w-lg mb-10">
            Our care is built around real needs, offering daily support, connection with families, and
            trusted professionals who make every day safer and more meaningful.
          </p>

          <div className="space-y-7">
            {features.map((f) => (
              <div key={f.title} className="flex items-start gap-4">
                <span className="shrink-0 mt-0.5 inline-flex items-center justify-center w-9 h-9 rounded-full border border-primary text-primary">
                  <ArrowRight size={16} />
                </span>
                <div>
                  <h3 className="text-ink font-medium text-lg">{f.title}</h3>
                  <p className="text-muted text-sm mt-1">{f.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Right */}
        <div className="relative">
          <img
            src={careImage}
            alt="A carer supporting an older person"
            className="w-full h-[420px] lg:h-[560px] object-cover rounded-2xl"
          />
        </div>
      </div>
    </section>
  );
};

export default CareThatMattersSection;
